(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
  angular
    .module('neo.home.resultats')
    .controller('resultatsCtrl', resultatsCtrl);

  function resultatsCtrl(userResolve,AclService,sancions, $window,$scope,EnvironmentConfig,recalcul, $http, resultat, valoracions,valoracionstecnicspartitslocal,valoracionstecnicspartitsvisitant,$state,$mdDialog,items) {
   var vm = this;
   
   $scope.sancions=sancions;
   vm.isAdmin = AclService.isAdmin; 
   
   $scope.title1="";$scope.title2="";$scope.title3="";$scope.title4="";$scope.title5="";$scope.title6="";$scope.title7="";$scope.title8="";$scope.title9="";$scope.title10="";
   $scope.tooltip1="";$scope.tooltip2="";$scope.tooltip3="";$scope.tooltip4="";$scope.tooltip5="";$scope.tooltip6="";$scope.tooltip7="";$scope.tooltip8="";$scope.tooltip9="";$scope.tooltip10="";
   var  local=0;
   var visitant=1;
   $scope.sancionaplicada=resultat[0].idsancion;
   vm.treure=(resultat[0].idsancion>0);
   vm.poteliminar=false;
   vm.espotVotar=true;
   if(resultat.length===1){
       var r={
       fecha:resultat[0].fecha,
       campionat:resultat[0].campionat,
        elocal:resultat[0].elocal,
    evisitant:resultat[0].evisitant,
    cc:[0].cc,
       pp:0,
       ptg:0,
       ptt:0,
       pte:0,
       pdt:0,
       pdp:0,
       marcador:0,
       verdplay:0,
       tv:0,
       idCampionat:resultat[0].idCampionat,
       puntsVisitant:0,totpunts:0,
       
       idPartido:resultat[0].idPartido,
       idLocal:resultat[0].idLocal,
       idVisitant:resultat[0].idVisitant
          };
       
       resultat.push(r);
   }
   if(resultat[0].idEquipo===0){
       alert("0");
       resultat[0].idEquipo=resultat[0].idLocal;
       resultat[1].idEquipo=resultat[0].idVisitant;
   }else
   {
   if (resultat[0].idEquipo===resultat[0].idLocal){
       local=0;
       visitant=1;
       resultat[1].idEquipo=resultat[0].idVisitant;
   } else{
       local=1;
       visitant=0;
       resultat[1].idEquipo=resultat[0].idLocal;
   }}
   $scope.sancionLocalBool=resultat[local].infractor; 
   $scope.sancionVisitBool=resultat[visitant].infractor; 
    vm.isDescalificatLocal=!resultat[local].isDescalificat; 
     vm.isDescalificatVisitant=!resultat[visitant].isDescalificat; 
     
    
   $scope.ccchange=function(){
       $http.get(EnvironmentConfig.API + '/acc/'+resultat[0].idPartido+'/'+!vm.cc).then(function(response){
           alert("Partit actualitzat");
       });
   };
   
   $scope.ccchangesuspes=function(){
       $http.get(EnvironmentConfig.API + '/asuspendre/'+resultat[0].idPartido).then(function(response){
           alert("Partit actualitzat. Aquesta actualitzacio nomes afecta a la APP. Haruia de suspendre/treure suspensio a PLAYOFF");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
   $window.location.reload();    
       });
   };
   $scope.truredescalificaciolocal=function(){
      var r=confirm('L\'Equip recuperarà totes les puntiacions. Es correcte?');
                   if (r){
                    $http.get(EnvironmentConfig.API + '/retirarsancioretirada/'+resultat[0].idCampionat+'/'+resultat[local].idEquipo).then(function(response){
                
           alert("Sancio retirada.");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
                     $window.location.reload();    
       });  
                   }
                   };
  
  $scope.truredescalificaciovisitant=function(){
      var r=confirm('L\'Equip recuperarà totes les puntiacions. Es correcte?');
                   if (r){
                    $http.get(EnvironmentConfig.API + '/retirarsancioretirada/'+resultat[0].idCampionat+'/'+resultat[visitant].idEquipo).then(function(response){
                
           alert("Sancio retirada.");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
                     $window.location.reload();    
       });  
                   }
                   };
  
   $scope.aplicarsancio=function(){
      
       if($scope.sancionaplicada===0){
           alert("Si us plau, seleccioneu una sanció a aplicar");
       } else{
           if(vm.sancionLocal===vm.sancionVisit){
                alert("Si us plau, seleccioneu UN equip sancionat");
           }else{
               if($scope.sancions[$scope.sancionaplicada-1].retirada){
                   var equipretirat="";
                   var equipretiratnom="";
                   if (vm.sancionVisit===2) {
                       equipretiratnom=resultat[visitant].evisitant;
                       equipretirat=resultat[visitant].idEquipo;}
                   else{
                       equipretirat=resultat[local].idEquipo;
                       equipretiratnom=resultat[local].elocal;
                   }
                   var r=confirm('La sanció implica la retirada de tots els punts de '+equipretiratnom+"-"+equipretirat);
                   if (r){
                          $http.get(EnvironmentConfig.API + '/aplicarsancioretirada/'+resultat[0].idCampionat+'/'+equipretirat+'/'+$scope.sancionaplicada).then(function(response){
                
           alert("Partit sancionat.");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
                     $window.location.reload();    
       });  
                   }
               }
               else{
                 $http.get(EnvironmentConfig.API + '/aplicarsancio/'+resultat[0].idPartido+'/'+resultat[visitant].idEquipo+'/'+$scope.sancionaplicada+'/'+vm.sancionVisit+'/'+resultat[visitant].idClasificacion);
                 $http.get(EnvironmentConfig.API + '/aplicarsancio/'+resultat[0].idPartido+'/'+resultat[local].idEquipo+'/'+$scope.sancionaplicada+'/'+vm.sancionLocal+'/'+resultat[local].idClasificacion).then(function(response){
                
           alert("Partit sancionat.");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
                     $window.location.reload();    
       });}
           }
       }
   };
   
    $scope.treuresancio=function(){
      var r=confirm("Segur que vol treure la sanció?");
       if(r){
          
                 $http.get(EnvironmentConfig.API + '/treuresancio/'+resultat[0].idPartido+'/'+resultat[visitant].idEquipo+'/'+$scope.sancionaplicada+'/'+vm.sancionVisit+'/'+resultat[visitant].idClasificacion);
                 $http.get(EnvironmentConfig.API + '/treuresancio/'+resultat[0].idPartido+'/'+resultat[local].idEquipo+'/'+$scope.sancionaplicada+'/'+vm.sancionLocal+'/'+resultat[local].idClasificacion).then(function(response){
                     
           alert("Sanció eliminiada.");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
                     $window.location.reload();    
       });
           }
       
   };
   
    vm.changesancio=function (idsancio){
        $scope.sancionaplicada=idsancio;
  
    };
   $scope.votar2=function(){
            
               recalcul.insert({idPartido:resultat[local].idPartido},resultat[0]);
               recalcul.insert({idPartido:resultat[local].idPartido},resultat[1]);
                  alert('Recalculat');
                 var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
   $window.location.reload();    
   };
     
   $scope.mesures=function(){
       if(resultat[0].idsancion>0){
          alert("Aquest partit està sancionat. No es poden aplicar mesures correctores.") 
       }else{
      $http.get(EnvironmentConfig.API + '/mesures/'+resultat[0].idPartido).then(function(response){
           alert("Partit actualitzat.");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                 window.open(url,'_self');
   $window.location.reload();    
       });
   }};   
  
    vm.ctrlName = 'resultatsCtrl';
    vm.campionat=resultat[local].campionat;
    vm.data=resultat[local].fecha.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1');;
    vm.elocal=resultat[local].elocal;
    vm.evisitant=resultat[local].evisitant;  
    vm.cc=resultat[local].cc;
 //   vm.ppl=resultat[local].pp;
 //   vm.ppv=resultat[visitant].pp;
    vm.ppl=0;
    vm.ppv=0;
     vm.ptgl=resultat[local].ptg;
    vm.ptgv=resultat[visitant].ptg;
 //    vm.pttl=resultat[local].ptt;
//    vm.pttv=resultat[visitant].ptt;

  vm.pttl=0;
  vm.pttv=0;
    // vm.ptel=resultat[local].pte;
   // vm.ptev=resultat[visitant].pte;
    
     vm.ptel=0;
    vm.ptev=0;
    
      vm.pdtl=resultat[local].pdt;
    vm.pdtv=resultat[visitant].pdt;
      vm.pdpl=resultat[local].pdp;
    vm.pdpv=resultat[visitant].pdp;
     vm.marcadorl=resultat[local].marcador;
    vm.marcadorv=resultat[visitant].marcador;
    vm.pvpl=resultat[local].verdplay;
    vm.pvpv=resultat[visitant].verdplay;
     vm.tvl=resultat[local].tv;
    vm.tvv=resultat[visitant].tv;
    vm.pl=resultat[local].puntsLocal;
     vm.pv=resultat[visitant].puntsVisitant;
    if (resultat[local].suspendido){
        vm.suspes="PARTIT SUSPES!!";
        vm.suspeschk=true;
    }else{
         vm.suspes=resultat[local].totpunts+ " - "+resultat[visitant].totpunts;
         vm.suspeschk=false;
    }
    //$scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idLocal,idperfil:5});
    
       //$scope.valoracionstecnics=valoracionstecnicspartitsvisitant;
  //var j= valoracionstecnicspartitsvisitant.length;
    $scope.valoracionstecnics=valoracionstecnicspartitslocal;
   // $scope.valoracionstecnics2=valoracionstecnics.query({idpartit:resultat[local].idPartido,idequip:resultat[visitant].idEquipo,idcampeonato:resultat[local].idCampionat});
 var j= valoracionstecnicspartitslocal.length;
   
   switch (j){
       case 1: if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto1={"background-color": "greenyellow"};
                 } else{  $scope.stboto1={"background-color": "red"};}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title1="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title1=$scope.title1+"C";}
                 $scope.tooltip1=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                 vm.partido1=$scope.valoracionstecnics[0].idPartido;
              break;
      case 2:  if ($scope.valoracionstecnics[1].isVotat){
                    $scope.stboto1={"background-color": "greenyellow"};
                 } else{  $scope.stboto1={"background-color": "red"};}
                  if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto2={"background-color": "greenyellow"};
                 } else{  $scope.stboto2={"background-color": "red"};}
                if ($scope.valoracionstecnics[1].isSuspes){$scope.title1="S";}
                if ($scope.valoracionstecnics[1].isCC){$scope.title1=$scope.title1+"C";}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title2="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title2=$scope.title2+"C";}
                 $scope.tooltip1=$scope.valoracionstecnics[1].idPartido+"-"+$scope.valoracionstecnics[1].fecha[2]+"/"+$scope.valoracionstecnics[1].fecha[1]+"/"+$scope.valoracionstecnics[1].fecha[0]+"-"+$scope.valoracionstecnics[1].equiplocal+"-"+$scope.valoracionstecnics[1].equipVisitant;
                 $scope.tooltip2=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                 vm.partido1=$scope.valoracionstecnics[1].idPartido;
                 vm.partido2=$scope.valoracionstecnics[0].idPartido;
              break;
        case 3:  if ($scope.valoracionstecnics[2].isVotat){
                    $scope.stboto1={"background-color": "greenyellow"};
                 } else{  $scope.stboto1={"background-color": "red"};}
                  if ($scope.valoracionstecnics[1].isVotat){
                    $scope.stboto2={"background-color": "greenyellow"};
                 } else{  $scope.stboto2={"background-color": "red"};}
                  if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto3={"background-color": "greenyellow"};
                 } else{  $scope.stboto3={"background-color": "red"};}
                if ($scope.valoracionstecnics[2].isSuspes){$scope.title1="S";}
                if ($scope.valoracionstecnics[2].isCC){$scope.title1=$scope.title1+"C";}
                if ($scope.valoracionstecnics[1].isSuspes){$scope.title2="S";}
                if ($scope.valoracionstecnics[1].isCC){$scope.title2=$scope.title2+"C";}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title3="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title3=$scope.title3+"C";}
                   $scope.tooltip1=$scope.valoracionstecnics[2].idPartido+"-"+$scope.valoracionstecnics[2].fecha[2]+"/"+$scope.valoracionstecnics[2].fecha[1]+"/"+$scope.valoracionstecnics[2].fecha[0]+"-"+$scope.valoracionstecnics[2].equiplocal+"-"+$scope.valoracionstecnics[2].equipVisitant;
                   $scope.tooltip2=$scope.valoracionstecnics[1].idPartido+"-"+$scope.valoracionstecnics[1].fecha[2]+"/"+$scope.valoracionstecnics[1].fecha[1]+"/"+$scope.valoracionstecnics[1].fecha[0]+"-"+$scope.valoracionstecnics[1].equiplocal+"-"+$scope.valoracionstecnics[1].equipVisitant;
                   $scope.tooltip3=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                 vm.partido1=$scope.valoracionstecnics[2].idPartido;
                 vm.partido2=$scope.valoracionstecnics[1].idPartido;
                  vm.partido3=$scope.valoracionstecnics[0].idPartido;
                    break;
       case 4:  if ($scope.valoracionstecnics[3].isVotat){
                    $scope.stboto1={"background-color": "greenyellow"};
                 } else{  $scope.stboto1={"background-color": "red"};}
                  if ($scope.valoracionstecnics[2].isVotat){
                    $scope.stboto2={"background-color": "greenyellow"};
                 } else{  $scope.stboto2={"background-color": "red"};}
                  if ($scope.valoracionstecnics[1].isVotat){
                    $scope.stboto3={"background-color": "greenyellow"};
                 } else{  $scope.stboto3={"background-color": "red"};}
                 if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto4={"background-color": "greenyellow"};
                 } else{  $scope.stboto4={"background-color": "red"};}
                
                if ($scope.valoracionstecnics[3].isSuspes){$scope.title1="S";}
                if ($scope.valoracionstecnics[3].isCC){$scope.title1=$scope.title1+"C";}
                if ($scope.valoracionstecnics[2].isSuspes){$scope.title2="S";}
                if ($scope.valoracionstecnics[2].isCC){$scope.title2=$scope.title2+"C";}
                if ($scope.valoracionstecnics[1].isSuspes){$scope.title3="S";}
                if ($scope.valoracionstecnics[1].isCC){$scope.title3=$scope.title3+"C";}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title4="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title4=$scope.title4+"C";}
                  $scope.tooltip1=$scope.valoracionstecnics[3].idPartido+"-"+$scope.valoracionstecnics[3].fecha[2]+"/"+$scope.valoracionstecnics[3].fecha[1]+"/"+$scope.valoracionstecnics[3].fecha[0]+"-"+$scope.valoracionstecnics[3].equiplocal+"-"+$scope.valoracionstecnics[3].equipVisitant;
                  $scope.tooltip2=$scope.valoracionstecnics[2].idPartido+"-"+$scope.valoracionstecnics[2].fecha[2]+"/"+$scope.valoracionstecnics[2].fecha[1]+"/"+$scope.valoracionstecnics[2].fecha[0]+"-"+$scope.valoracionstecnics[2].equiplocal+"-"+$scope.valoracionstecnics[2].equipVisitant;
                  $scope.tooltip3=$scope.valoracionstecnics[1].idPartido+"-"+$scope.valoracionstecnics[1].fecha[2]+"/"+$scope.valoracionstecnics[1].fecha[1]+"/"+$scope.valoracionstecnics[1].fecha[0]+"-"+$scope.valoracionstecnics[1].equiplocal+"-"+$scope.valoracionstecnics[1].equipVisitant;
                  $scope.tooltip4=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                 vm.partido1=$scope.valoracionstecnics[3].idPartido;
                 vm.partido2=$scope.valoracionstecnics[2].idPartido;
                  vm.partido3=$scope.valoracionstecnics[1].idPartido;
                   vm.partido4=$scope.valoracionstecnics[0].idPartido;
                    break;
                          
                
    default:break;
  }
    
    $scope.valoracionstecnics=valoracionstecnicspartitsvisitant;
   // $scope.valoracionstecnics2=valoracionstecnics.query({idpartit:resultat[local].idPartido,idequip:resultat[visitant].idEquipo,idcampeonato:resultat[local].idCampionat});
   var j= valoracionstecnicspartitsvisitant.length;
  
   switch (j){
       case 1: 
                 if ($scope.valoracionstecnics[0].isVotat){
                     $scope.stboto6={"background-color": "greenyellow"};
                      if ($scope.valoracionstecnics[0].isSuspes){$scope.title6="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title6=$scope.title6+"C";}
                    } else{  $scope.stboto6={"background-color": "red"};};
                    
                    $scope.tooltip6=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                    vm.partido6=$scope.valoracionstecnics[0].idPartido;
              break;
      case 2:  if ($scope.valoracionstecnics[1].isVotat){
                    $scope.stboto6={"background-color": "greenyellow"};
                 } else{  $scope.stboto6={"background-color": "red"};}
                  if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto7={"background-color": "greenyellow"};
                 } else{  $scope.stboto7={"background-color": "red"};}
                   if ($scope.valoracionstecnics[1].isSuspes){$scope.title6="S";}
                if ($scope.valoracionstecnics[1].isCC){$scope.title6=$scope.title6+"C";}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title7="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title7=$scope.title7+"C";}
                 $scope.tooltip6=$scope.valoracionstecnics[1].idPartido+"-"+$scope.valoracionstecnics[1].fecha[2]+"/"+$scope.valoracionstecnics[1].fecha[1]+"/"+$scope.valoracionstecnics[1].fecha[0]+"-"+$scope.valoracionstecnics[1].equiplocal+"-"+$scope.valoracionstecnics[1].equipVisitant;
                 $scope.tooltip7=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                 vm.partido6=$scope.valoracionstecnics[1].idPartido;
                 vm.partido7=$scope.valoracionstecnics[0].idPartido;
                    break;
        case 3:  if ($scope.valoracionstecnics[2].isVotat){
                    $scope.stboto6={"background-color": "greenyellow"};
                 } else{  $scope.stboto6={"background-color": "red"};}
                  if ($scope.valoracionstecnics[1].isVotat){
                    $scope.stboto7={"background-color": "greenyellow"};
                 } else{  $scope.stboto7={"background-color": "red"};}
                  if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto8={"background-color": "greenyellow"};
                 } else{  $scope.stboto8={"background-color": "red"};}
                    if ($scope.valoracionstecnics[2].isSuspes){$scope.title6="S";}
                if ($scope.valoracionstecnics[2].isCC){$scope.title6=$scope.title6+"C";}
                if ($scope.valoracionstecnics[1].isSuspes){$scope.title7="S";}
                if ($scope.valoracionstecnics[1].isCC){$scope.title7=$scope.title7+"C";}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title8="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title8=$scope.title8+"C";}
                   $scope.tooltip6=$scope.valoracionstecnics[2].idPartido+"-"+$scope.valoracionstecnics[2].fecha[2]+"/"+$scope.valoracionstecnics[2].fecha[1]+"/"+$scope.valoracionstecnics[2].fecha[0]+"-"+$scope.valoracionstecnics[2].equiplocal+"-"+$scope.valoracionstecnics[2].equipVisitant;
                   $scope.tooltip7=$scope.valoracionstecnics[1].idPartido+"-"+$scope.valoracionstecnics[1].fecha[2]+"/"+$scope.valoracionstecnics[1].fecha[1]+"/"+$scope.valoracionstecnics[1].fecha[0]+"-"+$scope.valoracionstecnics[1].equiplocal+"-"+$scope.valoracionstecnics[1].equipVisitant;
                   $scope.tooltip8=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                   vm.partido6=$scope.valoracionstecnics[2].idPartido;
                 vm.partido7=$scope.valoracionstecnics[1].idPartido;
                  vm.partido8=$scope.valoracionstecnics[0].idPartido;
                    break;
       case 4:  if ($scope.valoracionstecnics[3].isVotat){
                    $scope.stboto6={"background-color": "greenyellow"};
                 } else{  $scope.stboto6={"background-color": "red"};}
                  if ($scope.valoracionstecnics[2].isVotat){
                    $scope.stboto7={"background-color": "greenyellow"};
                 } else{  $scope.stboto7={"background-color": "red"};}
                  if ($scope.valoracionstecnics[1].isVotat){
                    $scope.stboto8={"background-color": "greenyellow"};
                 } else{  $scope.stboto8={"background-color": "red"};}
                 if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto9={"background-color": "greenyellow"};
                 } else{  $scope.stboto9={"background-color": "red"};}
                  if ($scope.valoracionstecnics[3].isSuspes){$scope.title6="S";}
                if ($scope.valoracionstecnics[3].isCC){$scope.title6=$scope.title6+"C";}
                if ($scope.valoracionstecnics[2].isSuspes){$scope.title7="S";}
                if ($scope.valoracionstecnics[2].isCC){$scope.title7=$scope.title7+"C";}
                if ($scope.valoracionstecnics[1].isSuspes){$scope.title8="S";}
                if ($scope.valoracionstecnics[1].isCC){$scope.title8=$scope.title8+"C";}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title9="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title9=$scope.title9+"C";}
                   $scope.tooltip6=$scope.valoracionstecnics[3].idPartido+"-"+$scope.valoracionstecnics[3].fecha[2]+"/"+$scope.valoracionstecnics[3].fecha[1]+"/"+$scope.valoracionstecnics[3].fecha[0]+"-"+$scope.valoracionstecnics[3].equiplocal+"-"+$scope.valoracionstecnics[3].equipVisitant;
                   $scope.tooltip7=$scope.valoracionstecnics[2].idPartido+"-"+$scope.valoracionstecnics[2].fecha[2]+"/"+$scope.valoracionstecnics[2].fecha[1]+"/"+$scope.valoracionstecnics[2].fecha[0]+"-"+$scope.valoracionstecnics[2].equiplocal+"-"+$scope.valoracionstecnics[2].equipVisitant;
                   $scope.tooltip8=$scope.valoracionstecnics[1].idPartido+"-"+$scope.valoracionstecnics[1].fecha[2]+"/"+$scope.valoracionstecnics[1].fecha[1]+"/"+$scope.valoracionstecnics[1].fecha[0]+"-"+$scope.valoracionstecnics[1].equiplocal+"-"+$scope.valoracionstecnics[1].equipVisitant;
                   $scope.tooltip9=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                   vm.partido6=$scope.valoracionstecnics[3].idPartido;
                   vm.partido7=$scope.valoracionstecnics[2].idPartido;
                   vm.partido8=$scope.valoracionstecnics[1].idPartido;
                   vm.partido9=$scope.valoracionstecnics[0].idPartido;
                    break;
                          
                
    default:break;
  }
   
      
   if(( vm.isAdmin())||(userResolve.email==='esportescolar@esplugues.cat')){
      $scope.users =  $scope.users  || [
        { id: 1, name: 'Tutor/a de joc a Equip local'},
        { id: 2, name: 'Tutor/a de joc a Equip visitant' },
 //       { id: 3, name: 'Tècnic/a local' },
 //       { id: 4, name: 'Tècnic/a visitant' },
 //       { id: 5, name: 'Públic local' },
 //       { id: 6, name: 'Públic visitant' },
        { id: 7, name: 'Tutor/a grada local' },
        { id: 8, name: 'Tutor/a grada visitant' }
      ];
  }
  else{
      var today = new Date();
var dd = today.getDate();
var mm = today.getMonth()+1; //January is 0!
var yyyy = today.getFullYear();

if(dd<10) {
    dd = '0'+dd;
} 

if(mm<10) {
    mm = '0'+mm;
} 

today = dd + '/' + mm + '/' + yyyy;
     
      var di=datediff(parseDate(vm.data), parseDate(today));
     
      if (di<3){
          vm.espotVotar=true;
     $scope.users =   [
        { id: 1, name: 'Tutor/a de joc a Equip local'},
        { id: 2, name: 'Tutor/a de joc a Equip visitant' }
        
      ]; }
  else{
       $scope.users =   [
        { id: 1, name: 'Tutor/a de joc a Equip local'},
        { id: 2, name: 'Tutor/a de joc a Equip visitant' }
        
      ]; 
       vm.espotVotar=false;
  }
  
  }
       $scope.diagidperfil=0;$scope.diagidpartit=0;$scope.diagidquip=0;
       
       vm.change=function (id){
              $scope.id=id;
          if (id===1){
             // $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idLocal,idperfil:5});
               $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idLocal+'/'+5)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
               $scope.diagidperfil=5;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idLocal;
             
          };
           if (id===2){
            //  $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idVisitant,idperfil:5});
               $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idVisitant+'/'+5)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               $scope.diagidperfil=5;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idVisitant;
          };
          if (id===3){
            //  $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idLocal,idperfil:4});
               $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idVisitant+'/'+4)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               $scope.diagidperfil=4;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idVisitant;
          };
            if (id===4){
            //  $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idVisitant,idperfil:4});
            $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idLocal+'/'+4)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               $scope.diagidperfil=4;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idLocal;
          };
            if (id===5){
            //  $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idLocal,idperfil:2});
            $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idVisitant+'/'+2)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               
               $scope.diagidperfil=2;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idVisitant;
          };
           if (id===6){
           //   $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idVisitant,idperfil:2});
                $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idLocal+'/'+2)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               $scope.diagidperfil=2;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idLocal;
          };
             if (id===7){
           //   $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idLocal,idperfil:1});
             $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idLocal+'/'+1)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               $scope.diagidperfil=1;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idLocal;
          };
             if (id===8){
            //  $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idVisitant,idperfil:1});
                $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idVisitant+'/'+1)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               $scope.diagidperfil=1;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idVisitant;
          };
          
         
          vm.canvi=function() {
          
          for(var k=0;k<$scope.valoracions.length;k++){
             var val= $scope.valoracions[k].valorCSV.split(";");
             var i=val.indexOf($scope.valoracions[k].vporc.toString());
             
             var valstring=$scope.valoracions[k].stringsCSV.split(";");
             
             if (valstring.length===1) {$scope.valoracions[k].vporc=val[i];}
             else
             {$scope.valoracions[k].vporc=valstring[i];}  
         }
          $scope.$applyAsync(); 
          };
       };
       $scope.verpartido=function(partido){
           var url = $state.href("home.resultats",{idPartit:partido});
           window.open(url,'_blank');
       };
       
         $scope.votar=function(partido){
             if(  ($scope.id===1)||($scope.id===2)){
           var url = $state.href("home.votacio",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idLocal,idEquip2:resultat[local].idVisitant});
             }
               if  ($scope.id===3){
           var url = $state.href("home.votaciotecnic",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idVisitant});
             }
              if  ($scope.id===4){
           var url = $state.href("home.votaciotecnic",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idLocal});
             }
               if  ($scope.id===7){
           var url = $state.href("home.votaciotutorgrada",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idLocal});
             }
             if  ($scope.id===8){
           var url = $state.href("home.votaciotutorgrada",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idVisitant});
             }
             if  ($scope.id===5){
           var url = $state.href("home.votaciopublic",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idVisitant});
             }
               if  ($scope.id===6){
           var url = $state.href("home.votaciopublic",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idLocal});
             }
                 window.open(url,'_self');
       };
       
       $scope.eliminarvotacio=function(perfil){
           var r2=confirm("Segur que vol eliminar les votacions del perfil "+perfil+" ?");
           
           if(r2){
               $http.get(EnvironmentConfig.API + '/eliminarvotacio/'+resultat[0].idPartido+'/'+$scope.diagidquip+'/'+$scope.diagidperfil).then(function(response){
                     
           alert("Votacions eliminades");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
                     $window.location.reload();    
       });
           }
       };
       function parseDate(str) {
    var mdy = str.split('/');
    return new Date(mdy[2], mdy[1], mdy[0]-1);
}
function datediff(first, second) {
   return Math.round((second-first)/(1000*60*60*24));
}

$scope.clicatlocal=function(a) {
    if(vm.isAdmin()){
    var idnotificacio=0;
    var nomequip="";
    if(a===1)  {idnotificacio=resultat[local].idEquipo;
    nomequip=resultat[0].elocal;}
    if(a===2)  {idnotificacio=resultat[visitant].idEquipo;nomequip=resultat[0].evisitant;}
     var r=confirm("Vols enviar un email d\'advertència de sanció?");
     if (r){
         var pobla="";
            $http.get(EnvironmentConfig.API + '/poblacio/'+idnotificacio).then(function(response){
                pobla=response.data;
                
          
            
          $http.get(EnvironmentConfig.API + '/teams/email/'+idnotificacio).then(function(response){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1; //January is 0!

                var yyyy = today.getFullYear();
                if (dd < 10) {
                    dd = '0' + dd;
                } 
                if (mm < 10) {
                    mm = '0' + mm;
                    } 
                var today = dd + '/' + mm + '/' + yyyy;
              var mailHtml='<div lang="CA"><div class="m_-4911676397197326094WordSection1"><p class="MsoNormal">Hola,<u></u><u></u></p><p class="MsoNormal">Els'
+' tècnics dels següents equips de la vostra entitat, acumulen dues o més '
+'setmanes consecutives sense realitzar les seves valoracions a través de '
+'l\'aplicació del Juga Verd Play: <u></u><u></u></p><table class="m_-4911676397197326094MsoNormalTable" style="width: 816.0pt; border-collapse: collapse" width="1088" cellspacing="0" cellpadding="0" border="0"><tbody><tr style="height: 19.5pt"><td style="width: 161.0pt; border: solid windowtext 1.0pt; background: #8db4e2; padding: 0cm 3.5pt 0cm 3.5pt; height: 19.5pt" width="215" nowrap="nowrap"><p class="MsoNormal" style="text-align: center" align="center"><b><span style="font-size: 14.0pt">MUNICIPI<u></u><u></u></span></b></p></td><td style="width: 264.0pt; border: solid windowtext 1.0pt; border-left: none; background: #8db4e2; padding: 0cm 3.5pt 0cm 3.5pt; height: 19.5pt" width="352" valign="bottom"><p class="MsoNormal" style="text-align: center" align="center"><b><span style="font-size: 14.0pt">CAMPIONAT<u></u><u></u></span></b></p></td><td style="width: 391.0pt; border: solid windowtext 1.0pt; border-left: none; background: #8db4e2; padding: 0cm 3.5pt 0cm 3.5pt; height: 19.5pt" width="521" valign="bottom"><p class="MsoNormal" style="text-align: center" align="center"><b><span style="font-size: 14.0pt">EQUIP<u></u><u></u></span></b></p></td></tr><tr style="height: 18.75pt"><td style="width: 161.0pt; border: solid windowtext 1.0pt; border-top: none; padding: 0cm 3.5pt 0cm 3.5pt; height: 18.75pt" width="215" nowrap="nowrap"><p class="MsoNormal" style="text-align: center" align="center"><span style="font-size: 14.0pt; font-family: &quot;Arial&quot;,&quot;sans-serif&quot;">'+pobla+'<u></u><u></u></span></p></td><td style="width: 264.0pt; border-top: none; border-left: none; border-bottom: solid windowtext 1.0pt; border-right: solid windowtext 1.0pt; padding: 0cm 3.5pt 0cm 3.5pt; height: 18.75pt" width="352" nowrap="nowrap"><p class="MsoNormal" style="text-align: center" align="center"><span style="font-size: 14.0pt; font-family: &quot;Arial&quot;,&quot;sans-serif&quot;">'+resultat[0].campionat+'<u></u><u></u></span></p></td><td style="width: 391.0pt; border-top: none; border-left: none; border-bottom: solid windowtext 1.0pt; border-right: solid windowtext 1.0pt; padding: 0cm 3.5pt 0cm 3.5pt; height: 18.75pt" width="521" nowrap="nowrap"><p class="MsoNormal" style="text-align: center" align="center"><span style="font-size: 14.0pt; font-family: &quot;Arial&quot;,&quot;sans-serif&quot;">'+nomequip+'<u></u><u></u></span></p></td></tr></tbody></table><p class="MsoNormal">Us recordem que, <b><u><span style="background: yellow">si'
+' un tècnic no valora durant &nbsp;tres setmanes consecutives, l\'equip '
+'perdrà els punts de classificació de manera temporal fins que es valori el següent partit. En cas d\'acumular 4 '
+'jornades consecutives sense valorar, els punts es perdran de manera '
+'permanent*</span>.</u></b><span style="color: black"><u></u><u></u></span></p><p class="MsoNormal">*El Comitè Organitzador actuarà en casos on un tècnic no participa del programa JVP de forma deliberada.<u></u><u></u></p><p class="MsoNormal">'
+'Recordeu que, els codis per valorar tant el tècnic com el tutor de grada de cada equip, els trobareu a la pestanya “EQUIPS” del vostre Playoff. '
+'<u></u><u></u></p><p class="MsoNormal">Preguem'
+' que informeu a tots els tècnics dels següents equips de la vostra '
+'entitat que, &nbsp;en finalitzar el partit han de realitzar les '
+'valoracions a través de l\'aplicació Juga Verd Play. Un cop el tut@r de '
+'joc envií les seves puntuacions, la resta d\'agents: públic, tutor de '
+'grada i tècnics, disposaran dels 15 minuts següents per enviar les seves'
+' valoracions, tal i com hem informat anteriorment a través de circulars '
+'informatives, i com marca la normativa. El partit també es pot valorar '
+'abans que ho faci el tut@r de joc.<u></u><u></u></p><p class="MsoNormal">Salutacions.<u></u><u></u></p><p class="MsoNormal"><u></u>&nbsp;<u></u></p><p class="MsoNormal"><u></u>&nbsp;<u></u></p><p class="MsoNormal"><b><span style="font-size: 10.0pt; color: #1f497d" lang="ES">Rocío Toré Luna<u></u><u></u></span></b></p><p class="MsoNormal"><b><span style="font-size: 10.0pt; color: #1f497d" lang="ES">Tècnica <u></u><u></u></span></b></p><p class="MsoNormal"><b><i><span style="font-size: 10.0pt; color: #1f497d" lang="ES">Consell Esportiu del Baix Llobregat<u></u><u></u></span></i></b></p><p class="MsoNormal"><span style="font-size: 7.0pt; font-family: Wingdings; color: navy" lang="ES">(</span><span style="font-size: 7.0pt; font-family: MINITypeRegular; color: navy" lang="PT-BR">:</span><span style="font-size: 10.0pt; color: #1f497d" lang="EN-GB">93 685 20 39 (Ext. 5)&nbsp;&nbsp; </span><b><span style="font-size: 8.0pt; color: #1f497d" lang="EN-GB"><u></u><u></u></span></b></p><p class="MsoNormal"><b><u><span style="font-size: 10.0pt; color: #0070c0" lang="ES"><a href="http://www.cebllob.cat/" target="_blank" rel="noreferrer"><span lang="EN-GB">www.cebllob.cat</span></a><u></u><u></u></span></u></b></p><p class="MsoNormal"><b><u><span style="font-size: 10.0pt; color: #0070c0" lang="ES"><u></u><span style="text-decoration: none">&nbsp;</span><u></u></span></u></b></p><p class="MsoNormal"><span style="font-size: 8.0pt; color: #1f497d" lang="EN-GB">Segueix-nos a<u></u><u></u></span></p><p class="MsoNormal"><a href="http://www.facebook.com/cebllob" target="_blank" rel="noreferrer"><span style="font-size: 8.5pt; font-family: &quot;Verdana&quot;,&quot;sans-serif&quot;; color: #49709c; text-decoration: none"><img id="m_-4911676397197326094Imagen_x0020_1" src="Webmail%20%20%20Fwd%20%20Av%C3%ADs%20sanci%C3%B3%20equips%20Jornada%2019_01_19%20(sense%20valoraci%C3%B3%20del%20t%C3%A8cnic)_files/a_002.png" alt="Troba\'ns a Facebook" width="22" height="22" border="0"></span></a><span style=\"color: #1f497d\">&nbsp;</span><a href=\"http://www.twitter.com/cebllob\" target=\"_blank\" rel=\"noreferrer\"><span style=\"font-size: 8.5pt; font-family: &quot;Verdana&quot;,&quot;sans-serif&quot;; color: #49709c; text-decoration: none\"><img id=\"m_-4911676397197326094Imagen_x0020_2\" src=\"Webmail%20%20%20Fwd%20%20Av%C3%ADs%20sanci%C3%B3%20equips%20Jornada%2019_01_19%20(sense%20valoraci%C3%B3%20del%20t%C3%A8cnic)_files/a.png\" alt=\"http://www.cebllob.com/cebllob06/Imagenes/iconos/twitter.png\" width=\"22\" height=\"22\" border=\"0\"></span></a><span style=\"color: #1f497d\" lang=\"ES\">&nbsp;</span><a href=\"http://www.youtube.com/cebllob\" target=\"_blank\" rel=\"noreferrer\"><span style=\"font-size: 8.5pt; font-family: &quot;Verdana&quot;,&quot;sans-serif&quot;; color: #49709c; text-decoration: none\"><img id=\"m_-4911676397197326094Imagen_x0020_3\" src=\"Webmail%20%20%20Fwd%20%20Av%C3%ADs%20sanci%C3%B3%20equips%20Jornada%2019_01_19%20(sense%20valoraci%C3%B3%20del%20t%C3%A8cnic)_files/a_003.png\" alt=\"http://www.cebllob.com/cebllob06/Imagenes/iconos/youtube.jpg\" width=\"23\" height=\"23\" border=\"0\"></span></a><span style=\"color: #1f497d\" lang=\"ES\">&nbsp;</span><a href=\"https://www.instagram.com/CEBLLOB/\" target=\"_blank\" rel=\"noreferrer\"><span style=\"color: #1f497d; text-decoration: none\"><img id=\"m_-4911676397197326094Imagen_x0020_4\" src=\"Webmail%20%20%20Fwd%20%20Av%C3%ADs%20sanci%C3%B3%20equips%20Jornada%2019_01_19%20(sense%20valoraci%C3%B3%20del%20t%C3%A8cnic)_files/a.jpeg\" alt=\"cid:image005.jpg@01D1E96F.F0412D60\" width=\"22\" height=\"22\" border=\"0\"></span></a><span style=\"color: #1f497d\" lang=\"ES\"><u></u><u></u></span></p><p class=\"MsoNormal\"><span style=\"color: #1f497d\" lang=\"ES\"><u></u>&nbsp;<u></u></span></p><p class=\"MsoNormal\"><b><span style=\"font-size: 8.0pt; color: #666666\">CONFIDENCIALITAT</span></b><span style=\"font-size: 8.0pt; color: #1f497d\" lang=\"ES\"><u></u><u></u></span></p><p class=\"MsoNormal\" style=\"text-align: justify; background: white\"><b><i><u><span style=\"font-size: 8.0pt; color: #1f497d\">Nota legal</span></u></i></b><i><span style=\"font-size: 8.0pt; color: #1f497d\">:'
+' Aquest missatge i qualsevol arxiu adjunt està destinat únicament a la '
+'persona a qui es dirigeix i és confidencial. Si vostè ha rebut aquest '
+'missatge per error, si us plau comuniqui-ho al remitent i esborri '
+'immediatament. La utilització, revelació i / o reproducció del missatge '
+'pot constituir un delicte.<u></u><u></u></span></i></p><p class="MsoNormal" style="text-align: justify; background: white"><b><i><u><span style="font-size: 8.0pt; color: #1f497d">Protecció de Dades</span></u></i></b><i><span style="font-size: 8.0pt; color: #1f497d">:'
+' L\'informem que les seves dades de contacte electrònic estan sent '
+'tractades d\'acord amb la Llei Orgànica 3/2018, LOPD-GDD i Normativa '
+'Europea 2016/679, RGPD de Protecció de Dades de Caràcter Personal, '
+'trobant-se incorporats a la base de dades de Consell Esportiu del Baix '
+'Llobregat a fi de enviament d\'informació, resposta a consultes, i '
+'contactes genèrics. Igualment l\'informem que podrà exercir els seus '
+'drets d\'accés, rectificació, oposició, supressió de les seves dades i '
+'les de limitació i portabilitat al seu tractament a través d\'una '
+'comunicació a la següent adreça de correu electrònic: <a href="mailto:cebllob@cebllob.cat" onclick="return rcmail.command(\'compose\',\'cebllob@cebllob.cat\',this)" rel="noreferrer">cebllob@cebllob.cat</a>.<u></u><u></u></span></i></p><p class="MsoNormal" style="text-align: justify"><b><i><u><span style="font-size: 8.0pt; color: #1f497d">Baixa</span></u></i></b><i><span style="font-size: 8.0pt; color: #1f497d">:'
+' Amb motiu de la Llei 34/2002 de 11 de Juliol, de Serveis de la Societat'
+' de la Informació i de Comerç Electrònic e Internet, LSSICE, l´informem '
+'que pot revocar en qualsevol moment, el consentiment per a la recepció '
+'d\'aquest servei, enviant un correu a la direcció abans esmentada '
+'indicant la paraula BAIXA.<u></u><u></u></span></i></p><p class="MsoNormal" style="text-align: justify"><i><span style="font-size: 8.0pt; color: #1f497d">Gràcies per la seva col·laboració<u></u><u></u></span></i></p><p class="MsoNormal"><u></u>&nbsp;<u></u></p><p class="MsoNormal"><u></u>&nbsp;<u></u></p></div></div></div></div></div></div>'
+'</div>'

+'</div>';
              var emailTo=response.data;
              var emailsubject="Avís sanció equips Jornada "+today+" (sense valoració del tècnic)";
               
              var emlCont="To:"+emailTo+'\n';
              emlCont+='Subject:'+emailsubject+'\n';
              emlCont+='X-Unsent: 1'+'\n';
              emlCont+='Content-Type: text/html;charset=UTF-8\n';
              emlCont+='\n';
              emlCont+="<DOCTYPE html><html><head>"+mailHtml+"</head></html>";
              var textFile=null;
              var data =new Blob([emlCont],{type:'text/plain'});
              textFile=window.URL.createObjectURL(data);
              var a=document.createElement('a');
              var linkText=document.createTextNode('fileLink');
              a.appendChild(linkText);
              a.href=textFile;
              a.id='fileLink';
              a.download=emailsubject+'.eml';
              a.style.visibility='hidden';
              document.body.appendChild(a);
              document.getElementById('fileLink').click();
              
              
              
            });     
       });  
     }
  };};
  }
  
}());


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


